export default __webpack_public_path__ + "static/media/what-is-lawyerup.aa860a96.gif";